import React from 'react'
import {IconLook} from './icon_look'

export const Icon = ({name}) => {
  const {color, fa} = IconLook[name]
  return <i className={fa} style={{backgroundColor: color}} />
}



// WEBPACK FOOTER //
// ./src/icon.js